import { useEffect, useState } from 'react';
import { clientConfig } from '../config';

export function useHubSpotChat() {
    const [isAvailable, setIsAvailable] = useState(false);

    useEffect(() => {
        (window as any).hsConversationsSettings = {
            ...(window as any).hsConversationsSettings,
            loadImmediately: false,
        };

        const hsScriptId = 'hs-script-loader';
        if (!document.getElementById(hsScriptId)) {
            const script = document.createElement('script');
            script.id = hsScriptId;
            script.src = `//js-eu1.hs-scripts.com/${clientConfig.HUBSPOT_PORTAL_ID}.js`;
            script.async = true;
            script.defer = true;
            document.body.appendChild(script);
        }

        const clearHubSpotCookies = () => {
            document.cookie.split(';').forEach((c) => {
                const name = c.split('=')[0].trim();
                if (/hubspot|hs_|__hs|^messagesUtk$/.test(name)) {
                    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
                }
            });
        };

        const start = (api: any) => {
            clearHubSpotCookies();

            const status = api.widget.status();
            if (status.loaded) {
                api.widget.remove();
            }

            api.on('widgetLoaded', () => {
                setIsAvailable(true);
            });

            api.widget.load();
        };

        if ((window as any).HubSpotConversations) {
            start((window as any).HubSpotConversations);
            return;
        }

        (window as any).hsConversationsOnReady = (window as any).hsConversationsOnReady || [];
        (window as any).hsConversationsOnReady.push(() => {
            if ((window as any).HubSpotConversations) {
                start((window as any).HubSpotConversations);
            }
        });

        const retryInterval = setInterval(() => {
            const api = (window as any).HubSpotConversations;
            if (api) {
                start(api);
                clearInterval(retryInterval);
            }
        }, 1000);

        return () => clearInterval(retryInterval);
    }, []);

    return isAvailable;
}
